import { EnvironmentInterface } from '@nutt/configuration';

export const environment: Readonly<EnvironmentInterface> = {
  isProduction: false,
  apiBaseUrl: 'https://morrenhofjansen.nutt.test.m4mapp.com/api/',
  clientId: 'f1d607de49156ceaf9020f7e4adee654',
  avatarBaseUrl: 'https://s3-eu-west-1.amazonaws.com/nutt-morrenhofjansen-test-azjo9/',
};
